const template=`
<widget-status></widget-status>
<div>
  <div class="textWidgetContent" ng-bind-html="widget.settings.text"></div>
  <div class="clearFix"></div>
</div>`;
export default template;
